/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRightSquare = createReactComponent("outline", "arrow-right-square", "IconArrowRightSquare", [["path", { "d": "M7 12l14 0", "key": "svg-0" }], ["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M3 10h4v4h-4z", "key": "svg-2" }]]);

export { IconArrowRightSquare as default };
//# sourceMappingURL=IconArrowRightSquare.mjs.map
